<!-- Member header -->
<div class="page-heading" *ngIf="!headerCollapsed && showHeader && member !== undefined && member !== null">
    <div class="pt-3 pl-4 pb-3" [ngClass]="{'ml-3': type === 'patient' && !communityEnabled}">
        <div class="row w-100">
            <div class="col-xl-3 col-sm-12" [ngClass]="{'pl-4': type === 'case'}">
                <div class="headerText row h-100">
                    <div *ngIf="type === 'patient' && communityEnabled" class="col-3 col-xl-3 my-auto pr-0 pl-0">
                        <img alt="Photo" class="headshot" src="{{getImageUrl(member.photo)}}"
                            style="width:4em;height:4em;margin-left:auto;margin-right:auto;display:block;">
                    </div>
                    <div class="col-9" [ngClass]="{'col-xl-9': type === 'patient', 'col-xl-11': type === 'case'}">
                        <div class="row">
                            <h3 *ngIf="type === 'case'"><i class="fal fa-folder-open" title="{{'CASE'|translate}}"
                                    style="width:40px"></i>
                                <a *ngIf="consentAllowed" class="pointer montserrat fa-white"
                                    (click)="openMember(member.id)">
                                    {{member.name.fullName}}
                                </a>
                                <span *ngIf="!consentAllowed" style="color:#fff">
                                    {{member.name.fullName}}
                                </span>
                            </h3>
                            <h3 *ngIf="type === 'patient'"><i *ngIf="!communityEnabled" class="fal fa-user"></i>
                                <span style="color:#fff">
                                    {{member.name.fullName}}
                                </span>
                            </h3>
                            <span *ngIf="mergedPatient()"
                                class="badge badge-pill badge-secondary badge-patient-merged ml-2">{{'PATIENT-MERGED' |
                                translate}}
                            </span>
                        </div>
                        <div class="row" *ngIf="member.name.preferredName"
                            [ngClass]="{'extra-left-margin': type === 'case'}">
                            <span>{{'PREFERRED-NAME' | translate}}:</span>
                            <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                                <span>{{member.name.preferredName}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="member.mrn" [ngClass]="{'extra-left-margin': type === 'case'}">
                            <span>
                                {{'CHANNELS-RECORD-NUMBER' | translate}}: {{member.mrn}}
                            </span>
                        </div>
                        <div class="row" [ngClass]="{'extra-left-margin': type === 'case'}">
                            <span>
                                {{'COMPOSITE-RISK-SCORE' | translate}} <span
                                    class="badge badge-patient-header badge-pill badge-secondary ml-2"
                                    title="{{'COMPOSITE-RISK-SCORE' | translate}}">{{compositeRiskScore}}</span>
                            </span>
                        </div>
                        <div class="row top-margin" *ngIf="false && !mergedPatient()"
                            [ngClass]="{'extra-left-margin': type === 'case'}">
                            <label class="k-checkbox-label" for="track-patient">
                                {{'TRACK-PATIENT' | translate:patientLabel}}
                            </label>
                            <input type="checkbox" id="track-patient" class="ml-2" [(ngModel)]="member.starred"
                                name="starred" (change)="setTrackMember(member.starred)" kendoCheckBox>
                        </div>
                        <div class="row" [ngClass]="{'extra-left-margin': type === 'case'}">{{'PATIENT-ID' |
                            translate:patientLabel}}:&nbsp;<strong>{{ member.id }}</strong><span
                                style="display: inline-flex" class="ml-2">
                                <div #tipA kendoTooltip [tooltipTemplate]="patientTimestampTemplate" position="right"
                                    class="keyboard-accessible" tabindex="0" showOn="none" aria-live="polite"
                                    (focus)="showTooltip(patientInfoTooltip,tipA)" aria-live="polite"
                                    (mouseover)="showTooltip(patientInfoTooltip,tipA)" (blur)="hideTooltip(tipA)"
                                    (mouseout)="hideTooltip(tipA)">
                                    <i #patientInfoTooltip title="" class="fa fa-info-circle pointer" role="button"
                                        attr.aria-label="{{'PATIENT-INFO' | translate}}"></i>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-nowrap mt-0 col-xl-2 col-sm-12">
                <div class="header-section w-100" *ngIf="member"
                    [ngClass]="{'pt-2': member.contact && member.contact.homePhoneNumber && member.contact.homePhoneNumber && member.contact.cellPhoneNumber}">
                    <div class="row w-100" *ngIf="member.dateOfBirth">
                        <div class="col-9 col-xl-8 text-left pl-2">
                            <span>{{member.dateOfBirth | date}} ({{'AGE' | translate}}
                                {{ member.dateOfBirth | age }})
                            </span>
                        </div>
                    </div>
                    <div class="row w-100" *ngIf="member.gender && member.gender.displayName">
                        <div class="col-9 col-xl-8 text-left pl-2">
                            <span>{{member.gender.displayName}}</span>
                        </div>
                    </div>
                    <div class="row w-100">
                        <div class="col-9 col-xl-8 text-left pl-2" *ngIf="member.address; let address">
                            <div class="row" *ngIf="address?.streetLine">
                                <div class="col">
                                    <span>{{address.streetLine}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="address?.streetLineAdditional">
                                <div class="col">
                                    <span>{{address.streetLineAdditional}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <span *ngIf="address.city">{{address.city}}</span>
                                    <span *ngIf="address.county">{{address.city ? ', ' + address.county:
                                        address.county}}</span>
                                    <span *ngIf="address.state">{{address.city || address.county ? ', ' +
                                        address.state.code:address.state.code}}</span>
                                    <span *ngIf="address.postalCode">{{address.city || address.county || address.state ?
                                        ', ' + address.postalCode : address.postalCode}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-sm-12 text-nowrap mt-2 left-separator" *ngIf="member">
                <div class="row w-100"
                    *ngIf="!member.contact || 
                        (!member.contact.email && !member.contact.homePhoneNumber && !member.contact.homePhoneNumber && !member.contact.cellPhoneNumber)">
                    <div class="col-3 col-xl-3"></div>
                    <div class="col-9 col-xl-9">
                        <span class="font-italic"> {{'NO-CONTACT-INFO' | translate }}</span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member && member.contact && member.contact.email">
                    <div class="col-3 col-xl-3 text-right pr-0"><span>{{'EMAIL' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2 ellipsis-text">
                        <a href="mailto:{{member.contact.email}}" style="color: white;"
                            title="{{'NEW-EMAIL-HINT' | translate}} ({{member.contact.email}})"
                            target="_blank">{{member.contact.email}}
                        </a>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member && member.contact && member.contact.homePhoneNumber">
                    <div class="col-3 col-xl-3 text-right pr-0">
                        <span>{{ 'HOME' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2">
                        <span *ngIf="member.contact">{{member.contact.homePhoneNumber | phone}} <i
                                *ngIf="member.homePhoneSafe" class="fas fa-shield-check"
                                title="{{'SAFE' | translate}}"></i></span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member && member.contact && member.contact.cellPhoneNumber">
                    <div class="col-3 col-xl-3 text-right pr-0"><span>{{'CELL' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2">
                        <span *ngIf="member.contact">{{member.contact.cellPhoneNumber | phone}} <i
                                *ngIf="member.cellPhoneSafe" class="fas fa-shield-check"
                                title="{{'SAFE' | translate}}"></i></span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member && member.contact && member.contact.workPhoneNumber">
                    <div class="col-3 col-xl-3 text-right pr-0"><span>{{'WORK-PHONE' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2">
                        <span *ngIf="member.contact">{{member.contact.workPhoneNumber | phone}}</span>&nbsp;<span
                            *ngIf="member.contact && member.contact.workPhoneNumberExtension">{{'PHONE-EXTENSION-PREFIX'
                            | translate}}&nbsp;{{member.contact.workPhoneNumberExtension}}&nbsp;</span> <i
                            *ngIf="member.workPhoneSafe" class="fas fa-shield-check" title="{{'SAFE' | translate}}"></i>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member && member.contact && member.contact.otherPhoneNumber">
                    <div class="col-3 col-xl-3 text-right pr-0"><span>{{'OTHER-PHONE' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2">
                        <span *ngIf="member.contact">{{member.contact.otherPhoneNumber | phone}} <i
                                *ngIf="member.otherPhoneSafe" class="fas fa-shield-check"
                                title="{{'SAFE' | translate}}"></i></span>
                    </div>
                </div>
                <div class="row w-100">
                    <div class="col-3 col-xl-3 text-right pr-0"><span>{{'VIDEO' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-9 text-left pl-2">
                        <span [ngClass]="{'pointer': member.contact.preferredVideoProvider.active}"
                            class="keyboard-accessible" *ngIf="member.contact && member.contact.preferredVideoProvider"
                            tabindex="0"
                            (keydown.enter)="member.contact.preferredVideoProvider.active && openVideo(member.contact.preferredVideoProvider.url)"
                            (keydown.space)="member.contact.preferredVideoProvider.active && openVideo(member.contact.preferredVideoProvider.url)"
                            (click)="member.contact.preferredVideoProvider.active && openVideo(member.contact.preferredVideoProvider.url)">{{member.contact.preferredVideoProvider?.name}}</span>
                        <span class="pointer keyboard-accessible"
                            *ngIf="(member.contact && !member.contact.preferredVideoProvider) || !member.contact"
                            (click)="editPatient()" tabindex="0" (keydown.enter)="editPatient()"
                            (keydown.space)="editPatient()">{{'SELECT-VIDEO-PROVIDER' | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-12 text-nowrap mt-2" *ngIf="member"
                [ngClass]="{'left-separator': member && (member.veteranStatus || member.housingStatus || member.householdSize || member.familyIncome || 
                                                         member.insurances.length > 0 || member.enhancedServices.length > 0)}">
                <div class="row w-100" *ngIf="member.veteranStatus && member.veteranStatus.displayName">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'VETERAN-STATUS' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <span>{{member.veteranStatus.displayName}}</span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member.familyIncome">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'FAMILY-INCOME' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <span>${{member.familyIncome | number}}</span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member.familyIncome && member.povertyLevel">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'POVERTY-LEVEL' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <span
                            [ngClass]="{'poverty-yes': member.familyIncome<member.povertyLevel}">{{getPovertyText(member.familyIncome,member.povertyLevel)}}
                        </span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member.housingStatus && member.housingStatus.displayName">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'HOUSING-STATUS' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <span>{{member.housingStatus.displayName}}</span>
                    </div>
                </div>
                <div class="row w-100" *ngIf="member.householdSize">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'HOUSEHOLD-SIZE' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <span>{{member.householdSize}}</span>
                    </div>
                </div>
                <div class="row w-100 k-text-ellipsis" *ngIf="insurancesText">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'MEDICAL-INSURANCE' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <div title="{{insurancesText}}" class="ellipsis-text">{{insurancesText}}
                        </div>
                    </div>
                </div>
                <div class="row w-100 k-text-ellipsis" *ngIf="getMemberMedicaidNumber()">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{getMemberMedicaidNumber().dictionary.displayName}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <div class="ellipsis-text">
                            {{getMemberMedicaidNumber().value}}
                        </div>
                    </div>
                </div>
                <div class="row w-100" *ngIf="enhancedServicesText">
                    <div class="col-3 col-xl-7 text-right pr-0">
                        <span>{{'ENHANCED-SERVICES' | translate}}:</span>
                    </div>
                    <div class="col-9 col-xl-5 text-left pl-2 ellipsis-text">
                        <div title="{{enhancedServicesText}}" class="ellipsis-text">{{enhancedServicesText}}</div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 col-sm-12 text-nowrap pl-0">
                <div class="row h-100">
                    <div class="col-10 my-auto">
                        <i class="fas fa-lg patient-edit" (click)="editPatient()"
                            attr.aria-label="{{ (canEditPatient && !mergedPatient() ? 'EDIT' : 'VIEW') | translate }}"
                            role="button" tabindex="0" (keydown.enter)="editPatient()" (keydown.space)="editPatient()"
                            [ngClass]="{'fa-edit': canEditPatient && !mergedPatient(), 'fa-eye': !canEditPatient || mergedPatient()}"
                            title="{{ (canEditPatient && !mergedPatient() ? 'EDIT' : 'VIEW') | translate }}">
                        </i>
                        <div *ngIf="communityEnabled && communityPortalEnabled && memberSelected"
                            style="position: absolute;top:-9px;left:45px;">
                            <a *ngIf="memberSelected.inviteStatus === null"
                                title="{{'COMMUNITY-INVITE-SEND' | translate}}"
                                (click)="openMethodDialog(memberSelected,'INVITE')" tabindex="0"
                                (keydown.enter)="openMethodDialog(memberSelected,'INVITE')"
                                (keydown.space)="openMethodDialog(memberSelected,'INVITE')">
                                <i class="fas fa-envelope fa-lg pointer pl-2"
                                    style="color: white;position: relative;top:2px"></i>
                            </a>
                            <a *ngIf="memberSelected.inviteStatus === 'REGISTERED'"
                                title="{{'COMMUNITY-INVITE-REGISTERED-ON' | translate}}{{memberSelected.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(memberSelected)}}">
                                <i class="fas fa-user-check icon-success fa-lg pl-2"></i>
                            </a>
                            <a *ngIf="memberSelected.inviteStatus === 'SENT'"
                                title="{{'COMMUNITY-INVITE-SENT-ON' | translate}}{{memberSelected.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(memberSelected)}}">
                                <i class="fas fa-paper-plane icon-warn fa-lg pl-2"></i>
                            </a>
                            <a *ngIf="memberSelected.inviteStatus === 'EXPIRED'"
                                title="{{'COMMUNITY-INVITE-EXPIRED' | translate}}{{memberSelected.inviteSentOrRegisteredDate | date: 'MMM d, y, h:mm a'}} {{getInviteFromOrganizationName(memberSelected)}}">
                                <i class="fas fa-ban icon-danger fa-lg pl-2" style="position: relative;top:2px"></i>
                            </a>
                            <a *ngIf="memberSelected.inviteStatus === 'SENT' || memberSelected.inviteStatus === 'EXPIRED'"
                                title="{{'COMMUNITY-INVITE-RESEND' | translate}}" class="ml-2 pointer"
                                (click)="openMethodDialog(memberSelected,'INVITE')">
                                <i class="fas fa-share fa-lg pl-2" style="color: white;position: relative;top:2px"></i>
                            </a>
                        </div>
                        <div class="pointer keyboard-accessible" style="position:absolute;top:-9px;" [ngStyle]="{'left': communityEnabled && communityPortalEnabled && memberSelected && (memberSelected.inviteStatus === 'SENT' || memberSelected.inviteStatus === 'EXPIRED') ? 
                            '115px' : communityEnabled && communityPortalEnabled && memberSelected ? '80px' : '45px'}"
                            (click)="editPatientConsent()" tabindex="0" (keydown.enter)="editPatientConsent()"
                            (keydown.space)="editPatientConsent()">
                            <a *ngIf="latestMemberConsent !== null" title="{{consentExpirationPeriod}}">
                                <i class="fas fa-signal-alt fa-lg pl-2" attr.aria-label="{{consentExpirationPeriod}}"
                                    role="button" [ngStyle]="{'color': consentColor, 'padding': '5px'}"></i>
                            </a>
                            <a *ngIf="latestMemberConsent === null && consentExpired === true"
                                title="{{'CONSENT-EXPIRED' | translate}}">
                                <i class="fas fa-signal-alt-slash fa-lg pl-2" role="button"
                                    attr.aria-label="{{'CONSENT-EXPIRED' | translate}}"
                                    [ngStyle]="{'color': '#dc5d3f', 'padding': '5px'}"></i>
                            </a>
                        </div>
                        <div *ngIf="eligibilityAPIEnabled && member && !mergedPatient() "
                            style="position:absolute;top:-40px;left:17px">
                            <a title="{{'VERIFY-MEDICAID-ELIGIBILITY' | translate}}"
                                (click)="checkMedicaidEligibility()" tabindex="0"
                                (keydown.enter)="checkMedicaidEligibility()"
                                (keydown.space)="checkMedicaidEligibility()">
                                <i class="fas fa-clipboard-check fa-lg pointer"
                                    attr.aria-label="{{'VERIFY-MEDICAID-ELIGIBILITY' | translate}}">
                                </i>
                            </a>
                        </div>
                    </div>
                    <div class="col-2 my-auto">
                        <app-collapsible [storageKey]="'header'" (collapsibleToggle)="headerCollapsed=$event">
                        </app-collapsible>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="page-heading-subtitle"
    *ngIf="!headerCollapsed && showHeader && member !== undefined && member !== null && (type === 'patient' || type === 'case') && communityEnabled && !member.testMember && !mergedPatient()">
    <div class="row w-100 h-100 pl-3">
        <div class="col-xl-2 col-2 text-left my-auto" style="padding-left:22px;max-width:125px;">
            <h6>
                <span class="text-uppercase dark-green">{{'HOUSEHOLD' | translate}}</span>
            </h6>
        </div>
        <div class="col-xl-10 col-10 my-auto">
            <div *ngFor="let linkedMember of linkedMembers; let i=index" style="float: left;" class="pr-4"
                [contextMenu]="linkedMember.relationship !== null ? contextMenuHousehold : null" [contextMenuValue]="linkedMember">
                <div *ngIf="linkedMember.consentAllowed === true" class="pointer"
                    (click)="onLinkedMemberChanged(linkedMember.memberId)">
                    <span style="display: inline-flex" [ngClass]="{'ml-0': i !== 1, 'ml-2': i === 1}">
                        <div #tipB kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="none"
                            (focus)="showTooltip(linkedMemberTooltip,tipB)"
                            (mouseover)="showTooltip(linkedMemberTooltip,tipB)" (blur)="hideTooltip(tipB)"
                            (mouseout)="hideTooltip(tipB)">
                            <a #linkedMemberTooltip
                                title="{{linkedMember.relationship !== null ? linkedMember.relationship.displayName : 'HEAD-OF-HOUSEHOLD' | translate}}">
                                <img *ngIf="(type === 'patient' || type === 'case') && communityEnabled" alt="Photo"
                                    class="headshot-small mr-1" src="{{getImageUrl(linkedMember.photo)}}"></a>
                        </div>
                    </span>
                    {{linkedMember.fullName}}
                </div>
                <div *ngIf="linkedMember.consentAllowed === false" style="opacity: .6;">
                    <span style="display: inline-flex" class="ml-2">
                        <div #tipC kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="none"
                            (focus)="showTooltip(headOfHouseholdTooltip,tipC)" aria-live="polite"
                            (mouseover)="showTooltip(headOfHouseholdTooltip,tipC)" (blur)="hideTooltip(tipC)"
                            (mouseout)="hideTooltip(tipC)">
                            <a #headOfHouseholdTooltip
                                title="{{linkedMember.relationship !== null ? linkedMember.relationship.displayName : 'HEAD-OF-HOUSEHOLD' | translate}}">
                                <img *ngIf="(type === 'patient' || type === 'case') && communityEnabled" alt="Photo"
                                    class="headshot-small mr-1" src="{{getImageUrl(linkedMember.photo)}}"></a>
                        </div>
                    </span>{{linkedMember.fullName}}
                </div>
            </div>
            <button class="btn btn-outline-dark float-left custom-button border border-secondary"
                style="color:#183433;margin-left:3px;" *ngIf="!isPartOfAHousehold && !member.testMember"
                (click)="openClientSearch()">
                <span class="text-uppercase mr-2">&nbsp;{{'ADD-HOUSEHOLD-MEMBER' | translate}}</span>
                <i class="fas fa-user-plus"></i>
            </button>
        </div>
    </div>
</div>

<div class="page-heading" style="height: 60px;"
    *ngIf="headerCollapsed && showHeader && member !== undefined && member !== null">
    <div class="row w-100 h-100 ml-4">
        <div class="pr-0 col-4 col-sm-3 my-auto">
            <div class="headerText row h-100">
                <div *ngIf="type === 'patient' && communityEnabled" class="col-3 col-sm-2 my-auto pl-0"
                    style="max-width: 50px">
                    <img alt="Photo" class="headshot-small mr-1" src="{{getImageUrl(member.photo)}}">
                </div>
                <div class="col-8 col-sm-9 my-auto">
                    <div class="row h-100">
                        <h5 *ngIf="type === 'case'"><i class="fal fa-folder-open pr-1"></i>
                            <a *ngIf="consentAllowed" class="pointer montserrat fa-white"
                                (click)="openMember(member.id)">
                                {{member.name.fullName}}
                            </a>
                            <span *ngIf="!consentAllowed">
                                {{member.name.fullName}}
                            </span>
                        </h5>
                        <h5 *ngIf="type === 'patient'"><i *ngIf="!communityEnabled" class="fal fa-user"
                                style="width: 20px;"></i><span>
                                {{member.name.fullName}}</span>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-7 text-nowrap mt-0 my-auto text-right">
            <div *ngIf="communityEnabled">
                <div *ngFor="let linkedMember of linkedMembers" style="float: left;" class="ml-4 pointer"
                    (click)="onLinkedMemberChanged(linkedMember.memberId)">
                    <img *ngIf="type === 'patient' && communityEnabled" alt="Photo" class="headshot-small mr-2"
                        src="{{getImageUrl(linkedMember.photo)}}">
                    <i *ngIf="type === 'case'" class="fal fa-folder-open pr-1"></i>
                    {{linkedMember.fullName}}
                </div>
            </div>
        </div>
        <div class="col-2 col-sm-2 text-nowrap mt-0 my-auto">
            <div class="row h-100">
                <div class="col-10 my-auto">
                    <app-collapsible [storageKey]="'header'" (collapsibleToggle)="headerCollapsed=$event">
                    </app-collapsible>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Patient Edit-->
<kendo-dialog [width]="1500" *ngIf="editPatientDialog" (close)="editPatientDialog = false">
    <kendo-dialog-titlebar>
        <h3>{{ (canEditPatient && !mergedPatient() ? 'EDIT-PATIENT': 'VIEW-PATIENT') | translate:patientLabel}}</h3>
    </kendo-dialog-titlebar>
    <app-patient-edit [isNew]="false" [isReadOnly]="!canEditPatient || mergedPatient()" #memberEdit
        (saved)="afterSavePatient($event)" (applied)="afterApplyPatient($event)" [member]="member" [openPatientConsentTab]="openPatientConsentTab">
    </app-patient-edit>    
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="editPatientDialog = false">
            {{ (canEditPatient && !mergedPatient() ? 'CANCEL' : 'CLOSE') | translate}}
        </button>
        <button appPreventClick preventTime="8000" kendoButton type="button" *ngIf="canEditPatient && !mergedPatient()"
            [disabled]="!memberEdit.formValid() || !memberEdit.formDirty() || memberEdit.formSaving()"
            (click)="memberEdit.apply();">
            {{ 'APPLY' | translate}}
        </button>
        <button appPreventClick preventTime="8000" kendoButton type="button" *ngIf="canEditPatient && !mergedPatient()"
            [disabled]="!memberEdit.formValid() || !memberEdit.formDirty() || memberEdit.formSaving()"
            (click)="memberEdit.save();">
            {{ 'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Patient Search-->
<app-household-add [member]="memberSelected" [open]="openClientSearchDialog" (closing)="closeAddHousehold()">
</app-household-add>

<app-member-send-selection [memberSelected]="memberSelected" [open]="openSendMethodDialog" [type]="sendMethodType"
    (closing)="closeSendMethod($event)">
</app-member-send-selection>

<ng-template #patientTimestampTemplate>
    <span>
        {{'ADDED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{member.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
        translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(member.createdOn),'g')}}</strong>
    </span>
    <br />
    <span>
        {{'UPDATED-BY-TIMESTAMP' | translate}}&nbsp;<strong>{{member.lastModifiedBy}}</strong>&nbsp;{{'TIMESTAMP-ON' |
        translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(member.lastModifiedOn),'g')}}</strong>
    </span>
</ng-template>

<context-menu #contextMenuHousehold>
    <ng-template contextMenuItem (execute)="deleteHandler($event)">
        <button class="dropdown-item household-dropdown-item k-text-uppercase col-2 ml-2">
            <i class="fas fa-user-minus mr-2"></i>{{'REMOVE-HOUSEHOLD-MEMBER' | translate }}
        </button>
    </ng-template>
</context-menu>

<!--Remove Household Member confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-HOUSEHOLD-MEMBER-REMOVAL' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedMemberName}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="unlinkMember()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Medicaid Eligibility-->
<app-patient-eligibility #patientEligibility></app-patient-eligibility>